export default __webpack_public_path__ + "static/media/averageEvaluatorTimeImage.bbb6f2bc.png";